import { gql } from 'graphql-request';

/**
 * Lightweight FirmClient fragment for LIST views (advisor clients list, global
 * search, messaging recipients, BAA account assignment).
 *
 * Every selection here is read by a list consumer, and every sub-selection
 * stays on the backend's cheap paths: no `household` subfield beyond `id`
 * (each extra subfield costs a DynamoDB GetItem per client), no
 * `notes`/`team`, `originFirmInviteLink` trimmed to `campaignName`, and
 * `pendingInvitations` trimmed to the two fields messaging reads. The heavy
 * client-detail shape is `FirmClientFragment`, which composes this fragment —
 * add shared fields HERE, detail-only fields THERE.
 *
 * The score fields (`financialCategoryScore`/`financialCategorization`) are
 * intentionally absent: orphaned since 2026-01-23 (ELE-784/ELE-802).
 */
export const FirmClientListItemFragment = gql`
  fragment FirmClientListItemFragment on FirmClient {
    id
    mode
    createdAt
    givenNamesDisplay
    familyNamesDisplay
    pendingInvitations {
      id
      inviteeEmail
    }
    originFirmInviteLink {
      id
      campaignName
    }
    household {
      id
    }
    individuals {
      age
      emailAddress
      familyName
      givenName
      profileColor
      phoneNumber
      profileImage
      userID
    }
    group {
      id
      name
    }
  }
`;
